module.exports = __webpack_public_path__ + "static/img/9.27c4c82.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/9.png
// module id = eBqe
// module chunks = 0